import React from 'react'
import DateRangeFormatter from '../../helpers/date-range-formatter'

function headerTitle(dateRange) {
  if (dateRange.isCurrentDay()) {
    return 'Today at Shedd'
  }

  if (dateRange.isCurrentWeek()) {
    return 'This Week at Shedd'
  }
  return DateRangeFormatter.toFullString(dateRange)
}

function headerSubTitle(dateRange) {
  if (dateRange.isCurrent) {
    return DateRangeFormatter.toShortString(dateRange)
  }
}

export default function HeaderTitle({ dateRange }) {
  return (
    <h1
      data-testid="heading"
    >
      {headerTitle(dateRange)}
      <span className="heading-2 block sm:inline ml-12">
        <span className="sr-only">,</span>
        {headerSubTitle(dateRange)}
      </span>
    </h1>
  )
}
